import React, { Component } from "react";
import { Icon, Label, Button, Modal, Divider,Grid,Input } from "semantic-ui-react";
import { source } from "react-aim";
import { toastr } from 'react-redux-toastr';
import { dispatch } from "@rematch/core";
import Accordion from "@zippytech/react-toolkit/Accordion";
import "@zippytech/react-toolkit/Accordion/index.css";
import Summary from "./PublishedPackComponent/Summary";
import Detail from "./PublishedPackComponent/Detail";
import Notes from "./IndesignComponent/Notes";
import objectId from "../../../../helpers/objectId";
import ExportToWord from "./IndesignComponent/ExportToWord";
import FileUploader from "../../../drive/Attachments/UppyFileUpload";
import { singleLineText, urlValidation } from "../../../common/RegexValidation";
import ShowPlaybookMetaData from "../drive/modals/ShowPlaybookMetaData";
import { Form } from "formsy-semantic-ui-react";
import Contributors from './IndesignComponent/Contributor';
import PlaybookIntegrationConfig from './PlaybookIntegrationConfig';
import ShowPlaybookMetaDataSchema from "../drive/modals/ShowPlaybookMetaDataSchema";
import SchemaModalForm from "../../../drive/FormBuilder/SchemaModalForm";
var moment = require("moment");
@source({
  mouseEnter: (props, component) =>
    dispatch.app.setHelpContext("Resource Pane"),
})
class PublishedPackResourcePane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDashboard: false,
      modalFlag: false,
      schema: null,
      shemaUpdationKey: "",
      metadataSchemaFlag:false,
      editItem: null,
      action: "",
      schemaJSON:false
    };
    this.editActivity = this.editActivity.bind(this);
    this.getPlaybookToExport = this.getPlaybookToExport.bind(this);
  }

  componentWillMount() {
    dispatch.organizationUnit.fetchTeams({ organizationId: this.props.selectedOrganisation.id, accountId: this.props.selectedAccount._id });
}

  editActivity() {
    this.props.selectedPracticeFlowActivity.packId =
      this.props.selectedPracticeLibrary._id;
    dispatch.createPack.editActivityAsync(
      this.props.selectedPracticeFlowActivity
    );
  }
  setMetaDataFlag = async (flag, schema, shemaUpdationKey) => {
    await this.setState({ modalFlag: flag, schema: schema, shemaUpdationKey: shemaUpdationKey });
  };
  setMetadataSchemaModalFlag = async (flag) => {    
    await dispatch.createPack.setSelectedDataItem(null)
    this.setState({ metadataSchemaFlag: flag, editItem: null, action: "Add"});
  };
setSchemaJsonFlag = (flag) => {
    this.setState({schemaJSON: flag})
  }
  onSubmitSchema = (schema) =>{
    this.props.selectedPracticeLibrary.metaDataSchema = schema;
    dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
  }
  setItemToEdit = async (data) => {
    this.setState({ editItem: data }, () => {
        this.setState({ metadataSchemaFlag: true, action: "Update"})
    });
  }
  onRemoveItem = (data) => {
    let updateOptions = this.props.selectedPracticeLibrary.metaDataSchema.filter(option => option.name !== data.name)
    let message = <div className="confirmMessage">
        <h3>Delete Metadata Schema</h3>
        <label>{data.title}</label>
        <p>Are you sure to delete this metadata schema?</p>
        <span >This action is not reversible</span>
    </div>
    toastr.confirm(message, {
        onOk: async () => {
            // dispatch.lifeCycle.updatePlaybookActivities(updateOptions)
            this.onSubmitSchema(updateOptions)
        }
    });
  }
  saveIntegrationConfigs = (configData) => {
    configData.organizationId = this.props.selectedOrganisation.id;
    configData.accountId = this.props.selectedAccount._id;
    configData.entityId = this.props.selectedPracticeLibrary._id;
    configData.entityName = "playbook";

    dispatch.integrations.addEntityIntegrationConfig(configData);
  };

  async getPlaybookToExport() {
    await dispatch.lifeCycle.getPlaybookToExport(
      this.props.selectedPracticeLibrary._id
    );
    var dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(this.props.playbookToExport));
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataStr);
    } else {
      //for firfox/chrome
      let link = document.createElement("a");
      link.href = dataStr;
      link.download = this.props.selectedPracticeLibrary.name + ".playbook";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  handleUppyModalClick = () => {
    this.setState({
      openDashboard: !this.state.openDashboard,
    });
  };

  close = () => {
    this.setState({ linkOpen: false, name: "", url: "" });
  };

  addLink = () => {
    let attachments =
      this.props.selectedPracticeLibrary &&
        this.props.selectedPracticeLibrary.attachments
        ? this.props.selectedPracticeLibrary.attachments
        : [];
    let document = {};
    document.documentName = this.state.name;
    document.documentId = objectId();
    document.documentUrl = this.state.url;
    document.uploadedBy = this.props.user && this.props.user._id;
    document.uploadedAt = moment();
    attachments.unshift(document);
    this.addAttachment(attachments);
    this.close();
  };

  addAttachment = (attachments) => {
    let attachmentPayload = {
      _id: this.props.selectedPracticeLibrary._id,
      name: this.props.selectedPracticeLibrary.name,
      data: {
        attachments: attachments,
      },
    };
    dispatch.lifeCycle.updatePlaybook(attachmentPayload);
  };
  checkForIntegrations = () => {
    if (this.props.selectedOrganisation) {
      if (this.props.integrationEntities) {
        if (this.props.integrationEntities["playbook"]) {
          if (this.isWorkspaceOwner() || this.isAuthor()) {
            return true;
          }
        }
      }
    }
    return false;
  };
  
   isManager = () => {
        let manager =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "Manager"
          );
        if (manager && manager.length > 0) {
          return true;
        }
        return null;
      };

  isAuthor = () => {
    const loggdinUserId = this.props.user.email;
    let author =
      this.props.selectedPracticeLibrary &&
      this.props.selectedPracticeLibrary.participants &&
      this.props.selectedPracticeLibrary.participants.filter((participant) => {
        return participant.role === "author";
      });
    if (author && author.length > 0) {
      return author.find((author) => author.email === loggdinUserId);
    }
    return null;
  };
  isContributor = () => {
      const loggdinUserId = this.props.user.email;
      let contributor =
        this.props.selectedPracticeLibrary &&
        this.props.selectedPracticeLibrary.participants &&
        this.props.selectedPracticeLibrary.participants.filter((participant) => {
          return participant.role === "contributor";
        });
      if (contributor && contributor.length > 0) {
        return contributor.find((contributor) => contributor.email === loggdinUserId);
      }
      return null;
    };
    
  isWorkspaceOwner = () => {
    // const loggdinUserId = this.props.user._id;
    let authors =
      this.props.currentOrganization &&
      this.props.currentOrganization.users &&
      this.props.currentOrganization.users.filter(
        (el) =>
          el.accountUserId === this.props.user._id &&
          el.role === "workspaceOwner"
      );
    if (authors && authors.length > 0) {
      return true;
    }
    return null;
  };
  render() {
    let metaDataFlag = false;
    const integrationEnabled = this.checkForIntegrations();
    // Below changes for KLM-9602
  //  if (this.isWorkspaceOwner() || this.isAuthor()) {
      if(this.props.selectedPracticeLibrary.status === 4 && (this.isAuthor() || this.isWorkspaceOwner() || this.isContributor())) {
        metaDataFlag = true
      }
      else if(this.props.selectedPracticeLibrary.status === 5) {
        metaDataFlag = false
      }
      else {
        metaDataFlag = false
      }
  //  }


    let integrationsForPlaybook = []

    if (this.props.integrationEntities && this.props.integrationEntities["playbook"]) {
      integrationsForPlaybook = [...this.props.integrationEntities["playbook"]];
      if (this.props.entityIntegrationsConfig && this.props.entityIntegrationsConfig.length > 0) {
        integrationsForPlaybook.forEach((integration) => {
          integration.isDefinedForEntity = false;
          this.props.entityIntegrationsConfig.forEach((entityConfig) => {
            if (integration.id == entityConfig.type && integration._id && entityConfig.integrationId) {
              integration.formData.forEach((item) => {
                item.value = entityConfig.formData[item.label]
              });
              integration.isDefinedForEntity = true;
              integration.entityIntegrationConfigId = entityConfig._id;
            }
          })
        });
      } else {
        integrationsForPlaybook.forEach((integration) => {
          integration.formData.forEach((item) => {
            delete item.value;
          });
        });
      }
    }



    const errorLabel = <div className="customErrorLabel" />;
    const expandTool = (
      <div className="plusMinusIcons">
        <Icon className="close" name="plus circle" />
        <Icon className="open" name="minus circle" />
      </div>
    );

    let counts = {};

    if (this.props.selectedPracticeLibrary) {
      counts.attachmentsLength = (
        <Label>
          {this.props.selectedPracticeLibrary.attachments &&
            this.props.selectedPracticeLibrary.attachments.length}
        </Label>
      );
      counts.notesLength = (
        <Label>
          {this.props.selectedPracticeLibrary.notes &&
            this.props.selectedPracticeLibrary.notes.length}
        </Label>
      );
    }

    return (
      <div className="accordianBox w_100">
        <div className="accordianPanel w_100">
          <Accordion
            expandTool={expandTool}
            horizontal
            className="practiceFlowResourcePane"
            enableKeyboardNavigation={false}
          >
           {[
            <div tabTitle="Summary">
              <div className="acc-header">Summary</div>
              <Summary
                selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                participantsData={this.props.participantsData}
                user={this.props.user}
                isAuthor = {this.isAuthor()}
                isWorkspaceOwner = {this.isWorkspaceOwner()}
                isContributor = {this.isContributor()}
              />
            </div>,
            <div tabTitle={<div>Team and Participants {<Label>{this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length}</Label>} </div>}>
              <div className="resourcePaneOverflow">
                <div className="acc-header">Team and Participants {<Label>{this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length}</Label>}</div>
                <Contributors
                  isPublished={true}
                  teamList={this.props.teamList}
                  selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                  isRoleChangeModalOpen={this.props.isRoleChangeModalOpen}
                  status={this.props.selectedPracticeLibrary.status}
                  showResourecePaneFlag={this.props.showResourecePaneFlag}
                  invitedUsersArray={this.props.invitedUsersArray}
                  playbookInvitaions={this.props.playbookInvitaions}
                  isPlaybookInvitationModalOpen={this.props.isPlaybookInvitationModalOpen}
                  selectedOrganisation={this.props.selectedOrganisation}
                  organizationId={this.props.organizationId}
                  user={this.props.user}
                  selectedAccount={this.props.selectedAccount}
                />
              </div>
            </div>,
            <div tabProps={{ title: "Overview" }}>
              <div className="acc-header">Overview</div>
              <Detail
                selectedPracticeLibrary={this.props.selectedPracticeLibrary}
              />
            </div>,
            <div tabTitle={<div>Comments {counts.notesLength} </div>}>
              <div className="acc-header"> Comments {counts.notesLength}</div>
              <div>
                <Notes
                  notes={this.props.selectedPracticeLibrary.notes}
                  user={this.props.user}
                  status={this.props.selectedPracticeLibrary.status}
                  selectedData={this.props.selectedPracticeLibrary}
                  arrangementPaneActiveButtonFlag={
                    this.props.arrangementPaneActiveButtonFlag
                  }
                  string="pulishPlaybook"
                  role={this.props.selectedOrganisation.role}
                />
              </div>
            </div>,
            <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>}>
              <div className="acc-header">
                {" "}
                Attachments {counts.attachmentsLength}
                {(this.props.selectedPracticeLibrary) && 
                    (this.props.selectedPracticeLibrary.status === 0 || this.isAuthor() || this.isWorkspaceOwner() || this.isContributor()) ? (
                  <span className="pull-right" style={{ margin: "4px 0px" }}>
                    <Button
                      className="button-info float-right"
                      style={{ padding: "7px 10px" }}
                      content="Upload File"
                      onClick={this.handleUppyModalClick}
                    />
                    <Button
                      className="button-info float-right"
                      style={{ padding: "7px 10px" }}
                      content="Add Link"
                      onClick={() => this.setState({ linkOpen: true })}
                    />
                  </span>
                ) : null}
              </div>
              <FileUploader
                data={this.props.selectedPracticeLibrary}
                action={this.addAttachment}
                openDashboard={this.state.openDashboard}
                handleUppyModalClick={this.handleUppyModalClick}
                entityName="playbook"
                playbookStatus={this.props.selectedPracticeLibrary.status}
                selectedOrganization={this.props.selectedOrganisation}
                selectedPlaybook={this.props.selectedPracticeLibrary}
                to="playbook"
                isAuthor = {this.isAuthor()}
                status={this.props.selectedPracticeLibrary.status}
                isWorkspaceOwner={this.isWorkspaceOwner()}
                isContributor={this.isContributor()}
              />
            </div>,
            integrationEnabled && integrationsForPlaybook.length > 0 ?  
              <div tabProps={{ title: "Integrations" }}>
                <div className="acc-header">Integrations</div>
                <div className="resourcePaneOverflow">
                  <PlaybookIntegrationConfig configData={integrationsForPlaybook} onSave={this.saveIntegrationConfigs} />
                </div>
              </div> : null,
            <div tabProps={{ title: "Export to Word" }}>
              <div className="acc-header">Export to Word</div>
              <div className="resourcePaneOverflow">
                <ExportToWord
                  selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                  currentPlaybookTemplate={this.props.currentPlaybookTemplate}
                  user={this.props.user}
                  isAuthor = {this.isAuthor()}
                  isWorkspaceOwner = {this.isWorkspaceOwner()}
                  isContributor = {this.isContributor()}       
                />
              </div>
            </div>,
            <div tabProps={{ title: "MetaData Schema" }}>
            <div className="acc-header">
              MetaData Schema 
              <span
                style={{ margin: "0 20px" }}
                className="clr-gray fs_italic"
              >
                {(metaDataFlag && this.props.selectedPracticeLibrary) &&
                (this.props.selectedPracticeLibrary.status === 0 || (this.props.selectedPracticeLibrary.status === 4 && ( this.isAuthor()|| this.isWorkspaceOwner() || this.isContributor)))? (
                    <Button
                    disabled={!metaDataFlag}
                    content="Edit JSON Schema"
                    className="button-submit float-right "
                    type="button"
                    onClick={() => this.setSchemaJsonFlag(true)}
                    />
                ) : null}
               {(metaDataFlag && this.props.selectedPracticeLibrary) &&
                (this.props.selectedPracticeLibrary.status === 0 || ( this.isAuthor()|| this.isWorkspaceOwner() || this.isContributor))? (
                    <Button
                    disabled={!metaDataFlag}
                    content="Add Schema"
                    className="button-submit float-right "
                    type="button"
                    onClick={() => this.setMetadataSchemaModalFlag(true)}
                    />
                ) : null}
              </span>
            </div>
            {this.props.selectedPracticeLibrary &&
            this.props.selectedPracticeLibrary.metaDataSchema && this.props.selectedPracticeLibrary.metaDataSchema.length > 0 ? (
              <div className="resourcePaneOverflow">
                <Grid>
                <Grid.Row>
                    <Grid.Column width={7}>
                        <div className='acc-header'>Name Field</div>
                    </Grid.Column>
                    <Grid.Column width={7}>
                        <div className='acc-header'>Type</div>
                    </Grid.Column>
                </Grid.Row>
                {this.props.selectedPracticeLibrary.metaDataSchema.map((m) => {
                    return (
                    <Grid.Row style={{ 'margin-bottom': '5px' }}>
                        <Grid.Column width={7}>
                        <Input style={{width: "180px"}} disabled placeholder="Title" value={m.title} />
                    </Grid.Column>
                    <Grid.Column width={7}>
                        <Input style={{width: "180px"}} disabled placeholder="Text Box" value={m.type} />
                    </Grid.Column>
                    <Grid.Column width={1}>
                        <Button icon="edit alternate" className="trash-color" onClick={() => this.setItemToEdit(m)} style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>
                    </Grid.Column>
                    <Grid.Column width={1}>
                        <Button icon="trash alternate" className="trash-color" onClick={() => this.onRemoveItem(m)} style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>
                    </Grid.Column>
                    </Grid.Row>
                    )
                })}
            </Grid>
              </div>
            ) : <span className="clr-orange">No metaData to display</span>}
          </div>,
            <div tabProps={{ title: "MetaData" }}>
              <div className="acc-header">
                MetaData
                <span
                  style={{ margin: "0 20px" }}
                  className="clr-gray fs_italic"
                >
                  {(metaDataFlag && this.props.selectedPracticeLibrary) &&
                   (this.props.selectedPracticeLibrary.status === 0 || ( this.isAuthor() || this.isWorkspaceOwner() || this.isContributor)) ? (
                    <Button
                      disabled={!metaDataFlag}
                      content="Edit"
                      className="button-submit float-right "
                      type="button"
                      onClick={() => this.setMetaDataFlag(true, this.props.selectedPracticeLibrary.metaData, "metaData")}
                    />
                  ) : null}
                </span>
              </div>
              {this.props.selectedPracticeLibrary &&
                this.props.selectedPracticeLibrary.metaData ? (
                <div className="resourcePaneOverflow">
                  <pre>
                    {JSON.stringify(
                      this.props.selectedPracticeLibrary.metaData,
                      null,
                      2
                    )}
                  </pre>
                </div>
              ) : <span className="clr-orange">No metaData to display</span>}
            </div>
            ].filter(elem => !!elem)}
          </Accordion>
        </div>
        <Modal
          className="basicModal"
          open={this.state.linkOpen}
          size="mini"
          onClose={this.close}
          closeOnEscape={true}
          closeOnDimmerClick={false}
          closeIcon
        >
          <Modal.Header>Add File</Modal.Header>
          <Divider style={{ margin: "10px 0 0px" }} />
          <Modal.Content scrolling>
            <Form
              noValidate
              ref={(ref) => (this.form = ref)}
              id="AddLink"
              onValid={(e) => this.setState({ validForm: true })}
              onInvalid={(e) => this.setState({ validForm: false })}
            >
              <Form.Input
                required
                name="Add Link Name"
                id="Add Link Name"
                label="Add Link Name"
                value={this.state.name}
                placeholder="Add Link Name"
                validations={{ matchRegexp: singleLineText }}
                errorLabel={errorLabel}
                validationErrors={{
                  matchRegexp:
                    "Max limit is 128. No space allowed in starting.",
                  isDefaultRequiredValue: `Link Name is required`,
                }}
                onChange={(e) => {
                  this.setState({ name: e.target.value.trim() });
                }}
                instantValidation={true}
                autoFocus={true}
              />

              <Form.Input
                required
                name="Add Url"
                id="Add Url"
                label="Add Url"
                value={this.state.url}
                placeholder="Add Url"
                validations={{ matchRegexp: urlValidation }}
                errorLabel={errorLabel}
                validationErrors={{
                  matchRegexp: "Enter valid URL",
                  isDefaultRequiredValue: `Url is required`,
                }}
                onChange={(e) => {
                  this.setState({ url: e.target.value.trim() });
                }}
                instantValidation={true}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions
            className="actionInFormcy border-none pad_0"
            style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}
          >
            <Button
              disabled={!this.state.validForm}
              content="Add Link"
              className="button-submit float-right"
              type="button"
              onClick={this.addLink}
            />
            <Button
              content="Cancel"
              className="button-cancel"
              type="button"
              onClick={this.close}
            />
          </Modal.Actions>
        </Modal>
        <ShowPlaybookMetaData
          open={this.state.modalFlag}
          setMetaDataFlag={this.setMetaDataFlag}
          selectedPracticeLibrary={this.props.selectedPracticeLibrary}
          metaDataSchema={
            this.state.schema
          }
          view="playbook"
          shemaUpdationKey={this.state.shemaUpdationKey}

        />
        <ShowPlaybookMetaDataSchema
          open={this.state.schemaJSON}
          setMetaDataFlag={this.setSchemaJsonFlag}
          metaDataSchema={this.props.selectedPracticeLibrary.metaDataSchema}
          onSubmitSchema={this.onSubmitSchema}
        />
        {this.state.metadataSchemaFlag &&
          <SchemaModalForm
            open={this.state.metadataSchemaFlag}
            close={this.close}
            schemaOpen={this.setMetadataSchemaModalFlag}
            onSubmitSchema={this.onSubmitSchema}
            schema={this.props.selectedPracticeLibrary.metaDataSchema}
            selectedItem={this.state.editItem}
            action={this.state.action}
          /> }
      </div>
    );
  }
}

export default PublishedPackResourcePane;
